import { render, staticRenderFns } from "./ShapeLayer.vue?vue&type=template&id=dfdce2f2"
import script from "./ShapeLayer.vue?vue&type=script&lang=js"
export * from "./ShapeLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports